/* eslint-disable @typescript-eslint/no-empty-function */
import { get } from 'lodash'
import React, { createContext, ReactNode, useContext } from 'react'
import io from 'socket.io-client'

export type TSystemContextProvider = {
  children: ReactNode
}

const SystemContext = createContext({})

export const SystemContextProvider = ({
  children,
}: TSystemContextProvider): React.ReactElement => {
  if (!get(global, 'URL_SKYNET')) {
    return children as React.ReactElement
  }

  const socket = io(`${get(global, 'URL_SKYNET')}` + '/' + 'system', {
    transports: ['websocket'],
    upgrade: false,
  })

  socket.on('connect', () => {
    socket.emit(
      'authenticate',
      {
        token: get(global, 'jwtToken'),
      },
      (err: string) => {},
    )
  })

  socket.on('disconnect', () => {})

  socket.on('connect_error', () => {})

  socket.on('logout', () => {
    if (!sessionStorage.getItem('loggingOut')) {
      location.href = `${window.location.origin}/logout`
    }

    sessionStorage.removeItem('loggingOut')
  })
  socket.on('tenant_switch', () => {
    location.reload()
  })

  return <SystemContext.Provider value={{}}>{children}</SystemContext.Provider>
}
